import React, { useMemo } from "react";
import DocumentTitle from "react-document-title";

import categories, { findArticle } from "../../data/faqs/index";
import { extractHeadings, readingMinutes, relatedArticles } from "../../lib/article";
import { getCsWhatsAppUrl } from "../../lib/contact";
import ArticleAside from "../../components/Help/ArticleAside";
import ArticleBody from "../../components/Help/ArticleBody";
import Breadcrumbs from "../../components/Help/Breadcrumbs";
import CategoryRail from "../../components/Help/CategoryRail";
import FeedbackBlock from "../../components/Help/FeedbackBlock";
import NotFound from "../NotFound/NotFound";

/**
 * /help/<category>/<article>: three-level breadcrumb, the same rail as the
 * category page, then the article with its side column (spec section 6).
 */
const Article = ({ match }) => {
  const article = findArticle(match.params.category, match.params.article);

  // Memoised per article: the side column subscribes to scroll for the
  // current heading and would resubscribe on every render otherwise.
  const details = useMemo(() => {
    if (article === null) return null;

    return {
      headings: extractHeadings(article.content),
      minutes: readingMinutes(article.content),
      related: relatedArticles(article, categories),
      // The chat opens already knowing which article sent the reader.
      chatUrl: getCsWhatsAppUrl(`Halo Kyou, aku sudah baca "${article.title}" di Help Center tapi masih butuh bantuan.`)
    };
  }, [article]);

  if (article === null) return <NotFound />;

  return (
    <DocumentTitle title={`${article.title} - Kyou Help Center`}>
      <div className="hc-page">
        <div className="hc-container">
          <Breadcrumbs
            items={[
              { label: "Help Center", to: "/" },
              { label: article.category.title, to: `/${article.category.slug}` },
              { label: article.title }
            ]}
          />

          <div className="hc-split">
            <CategoryRail categories={categories} activeSlug={article.category.slug} />

            <div className="hc-artsplit">
              <article className="hc-article">
                <h1 className="hc-article__title">{article.title}</h1>
                <div className="hc-article__meta">
                  <span>{article.category.title}</span>
                  <span>Dibaca {details.minutes} menit</span>
                </div>
                <ArticleBody content={article.content} headings={details.headings} />
                <FeedbackBlock key={article.id} articleId={article.id} chatUrl={details.chatUrl} />
              </article>

              <ArticleAside headings={details.headings} related={details.related} chatUrl={details.chatUrl} />
            </div>
          </div>
        </div>
      </div>
    </DocumentTitle>
  );
};

export default Article;
